import React from 'react';
import { Flex } from 'rebass';
import styled from 'styled-components';
import colors from 'theme/colors';

const StyledTooltip = styled(Flex)`
  position: relative;
  display: inline-block;
  :hover {
    #tooltipText {
      visibility: visible;
    }
  }
`;

export const TooltipText = styled.span<any>`
  visibility: hidden;
  width: ${props => props.width};
  border: 1px solid ${colors.darkGray};
  background: ${colors.white};
  color: ${colors.primary};
  font-size: 20px;
  text-align: center;
  padding: ${props => props.padding};
  position: absolute;
  z-index: 1;
  top: ${props => props.top};
  right: ${props => props.right};
  left: ${props => props.left};
`;

const Tooltip: React.FC<any> = ({ children }) => <StyledTooltip>{children}</StyledTooltip>;

export default Tooltip;
